module.exports = __webpack_public_path__ + "statics/img/noData.2d0fb89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/noData.png
// module id = OFBL
// module chunks = 1